import { Component, OnInit, Inject, Input } from '@angular/core';
import { KeycloakInstance } from 'keycloak-js';
import { LumiloginService } from '../service/lumilogin.service';
import { LUMILOGIN_URL, LUMILOGIN_REALM, APPLICATION_NAME } from '../lumilogin.token';
import { applications } from '../metadata';
import { TranslateService } from '@ngx-translate/core';
import { TranslationLoaderService } from '../service/translation-loader.service';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss']
})
export class HeaderComponent implements OnInit {

  public lumiloginAuth: KeycloakInstance;
  private static url:string = "";
  private static realm:string = "";
  public applications;
  public name;

  constructor(private lumilogin: LumiloginService, 
              @Inject(LUMILOGIN_URL) private url: string, 
              @Inject(LUMILOGIN_REALM) private realm: string,
              @Inject(APPLICATION_NAME) private applicationName: string,
              private _translateService: TranslateService,
              public _translationLoaderService: TranslationLoaderService) { 
    HeaderComponent.url = url;
    HeaderComponent.realm = realm;
    this.name = this.displayAppName(applicationName);
  }

  ngOnInit() {
    this.lumiloginAuth = this.lumilogin.getKeycloakAuth();
    this.applications = applications;
  }

  login() {
    this.lumilogin.login();
  }

  logout() {
    this.lumilogin.logout();
  }

  displayUserInfo() {
    return this.lumilogin.getFullName();
  }

  getCompanyName() {
    return this.lumilogin.getCompanyName() === '' ? '-' : this.lumilogin.getCompanyName();
  }

  getAccountUrl() {
    return HeaderComponent.url + 'realms/' + HeaderComponent.realm + '/account';
  }

  initialName() {
    return this.lumilogin.getFullName().split(' ').map(s => s[0]).join('');
  }

  isLoggedIn(){
    return this.lumilogin.isLoggedIn();
  }

  displayAppName(name: string){
    let string = 'BackOffice';
    applications.forEach(app => {
      if (app.name.toLowerCase() === name.toLowerCase()) {
        string = app.name.replace('Lumi' , '');
      }
    })
    return string;
  }

  setLanguage(lang): void {
      this._translationLoaderService.setLanguage(lang);
  }
}